/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://sg.osim.com",
  "jssAppName": "osim-web-shop",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Mon Apr 22 2024 18:28:24 GMT+0700 (Indochina Time)",
  "gitVersion": "57337b297e411db305334b4145087ff54dadd58f",
  "graphQLEndpoint": "https://sg.osim.com/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};